export default __webpack_public_path__ + "assets/images/4b571e9b1f472d03cf2df296626a9b7e.svg";